import { FC, ReactNode } from "react";
import { PencilIcon } from "shared/ui";

import styles from "./UserProfile.module.css";

interface Props {
  label: string;
  editable?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

export const ProfileField: FC<Props> = ({
  label,
  editable = false,
  onClick,
  children,
}) => (
  <li className={styles.listItem}>
    <p className={styles.label}>{label}</p>
    <button
      type="button"
      className={`${styles.value} ${editable ? styles.editable : styles.uneditable}`}
      onClick={onClick}
      disabled={!editable}
    >
      {children}
      {editable && (
        <PencilIcon className={styles.editIcon} fill="currentColor" />
      )}
    </button>
  </li>
);
